<template>
  <div class="nav-bar">
    <img src="@/assets/images/logo3.png" width="140" height="35" class="icon">
<!--    <icon v-if="false" icon-class="logo" :h="60" :w="120" class="icon"/>-->
    <i v-if="!desktop" class="el-icon-d-arrow-left scroll-arrow"></i>
    <el-scrollbar>
      <el-menu :default-active="$route.path" class="menu" mode="horizontal" background-color="#ffffff"
               text-color="#005BAA" active-text-color="#1E90FF" router="true">
        <el-menu-item v-for="menu in menuItem" :key="menu" :index="'/'+menu" :route="menu">{{ menu }}</el-menu-item>
      </el-menu>
    </el-scrollbar>
    <i v-if="!desktop" class="el-icon-d-arrow-right scroll-arrow"></i>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      desktop: this.handleResize(),
      menuItem: [
        "Home", "News", "Research", "Members", "Publications", "Openings", "Contact"
      ],
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.desktop = this.handleResize();
      })();
    };
  },
  methods: {
    handleResize() {
      return document.documentElement.clientWidth > 930;
    }
  }
}
</script>

<style scoped>
.nav-bar {
  width: 100%;
  margin-right: 32px;
  height: 60px;
  background: white;
  /*background: #005BAA;*/
  font-size: 20px;
}

.icon {
  margin: 10px 16px 10px 10px;
}

.menu {
  display: inline-block;
}

.nav-bar::v-deep(.el-scrollbar) {
  display: inline-block;
  width: calc(100% - 238px);
  height: 61px;
}

.nav-bar::v-deep(.el-scrollbar__thumb) {
  background-color: dodgerblue;
}

.nav-bar ::v-deep(.el-menu) {
  border: none;
  height: 60px;
  white-space: nowrap;
}

.nav-bar ::v-deep(.el-menu-item) {
  font-size: 20px;
  font-weight: bold;
  float: none;
  display: inline-block;
}

.scroll-arrow {
  color: #005BAA;
  line-height: 60px;
  vertical-align: top;
  margin: 0 6px;
}
</style>